<template>
  <v-col :cols="cols" :sm="sm" :md="md" class="d-flex" :class="justifyClass">
    <ui-button variant="secondary" w120 class="mr-3" @click="$emit('reset')">
      {{ $t('base.resetFilters') }}
    </ui-button>
    <ui-button variant="apply" class="mb-0" @click="$emit('apply')">
      {{ $t(applyLabel) }}
    </ui-button>
  </v-col>
</template>

<script>
export default {
  name: 'FilterActions',
  props: {
    cols: {
      type: [String, Number],
      default: '12',
    },
    sm: {
      type: [String, Number],
      default: undefined,
    },
    md: {
      type: [String, Number],
      default: undefined,
    },
    justify: {
      type: String,
      default: 'center-end',
      validator: v => ['center-end', 'end', 'space-between-end'].includes(v),
    },
    applyLabel: {
      type: String,
      default: 'base.apply',
    },
  },
  computed: {
    justifyClass() {
      switch (this.justify) {
        case 'end':
          return 'justify-end'
        case 'space-between-end':
          return 'justify-space-between justify-sm-end'
        default:
          return 'justify-center justify-sm-end'
      }
    },
  },
}
</script>
